if (!window.constants) {
  window.constants = {};
}

window.constants.imageUrl = 'https://dndw32r4edmw5.cloudfront.net/assets/frontend-js/images/';
window.constants.videoUrl = 'https://dndw32r4edmw5.cloudfront.net/assets/frontend-js/videos/';
window.constants.soundUrl = 'https://dndw32r4edmw5.cloudfront.net/assets/frontend-js/sound/';
window.constants.bucketCloudfront = 'https://dndw32r4edmw5.cloudfront.net';

window.constants.rethumbUrl = 'https://api.rethumb.com/v1/';
window.constants.cloudinaryUrl = 'https://res.cloudinary.com/lyearn/image/fetch/';

window.constants.humanFileSize = function(B, i) {
  const a = i ? 1e3 : 1024;
  if (Math.abs(B) < a) return B + ' B';
  const t = i
    ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];

  let e = -1;
  do (B /= a), ++e;
  while (Math.abs(B) >= a && e < t.length - 1);
  return B.toFixed(0) + ' ' + t[e];
};

window.constants.s3LyearnScormUploadUrl = 'https://lyearn.s3.amazonaws.com/lyearn/scorm';

if (process.env.MY_ENV === 'production') {
  window.constants.s3LyearnAssetsUrl = 'https://lyearn.s3.amazonaws.com/lyearn/assets/';
  window.constants.s3LyearnBucketUrl = 'https://lyearn.s3.amazonaws.com/lyearn/';
  window.constants.bucketCloudfront = 'https://dndw32r4edmw5.cloudfront.net';
  window.constants.bucketLyearnCloudfront = 'https://dndw32r4edmw5.cloudfront.net/lyearn/';
  window.constants.s3BucketUrl = 'https://lyearn.s3.amazonaws.com/';
} else {
  window.constants.s3LyearnAssetsUrl = 'https://lyearn.s3.amazonaws.com/dev/lyearn/assets/';
  window.constants.s3LyearnBucketUrl = 'https://lyearn.s3.amazonaws.com/dev/lyearn/';
  window.constants.bucketCloudfront = 'https://dndw32r4edmw5.cloudfront.net/dev/';
  window.constants.bucketLyearnCloudfront = 'https://dndw32r4edmw5.cloudfront.net/dev/lyearn/';
  window.constants.s3BucketUrl = 'https://lyearn.s3.amazonaws.com/dev/';
}

global.constants = window.constants;
